import { useExperimentFeatureFlagVariant } from '@taxfix/scouts-helpers'

import { useMakeFeatureFlagSticky } from './utils'

type OnboardingProductSelectionUiUpdatesExperimentVariant = 'control' | 'test'

const experimentName = 'feat-onboarding-product-selection-ui-updates'
const stickyExperimentIdentifier = 'feat_onboarding_product_selection_ui_updates_variant'

export const useStickyOnboardingProductSelectionExperiment = () => {
    const variant =
        useExperimentFeatureFlagVariant<OnboardingProductSelectionUiUpdatesExperimentVariant>(experimentName)

    useMakeFeatureFlagSticky(stickyExperimentIdentifier, variant, experimentName)

    return {
        variant,
        isTestVariant: variant === 'test',
    }
}
